export default "__VITE_ASSET__9WMDBEbu__"